import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import * as React from 'react';
import { Link } from 'react-router-dom';

import classnames from '../../../utils/classnames.tsx';
import { withIcon } from '../../Icon.tsx';
import PageHeaderSeparator from './PageHeaderSeparator.tsx';

const BackIcon = withIcon(faArrowLeft);

/** The parent crumb of a detail page header (Automation Hub config header): a back arrow and the parent's name as
 *  one link, followed by the separator. The page's own title follows as a `Page.HeaderTitle`. */
const PageHeaderBreadcrumb = ({
    to,
    className,
    children,
    separator = true,
    ...props
}: React.ComponentPropsWithRef<typeof Link> & { separator?: boolean }) => (
    <>
        <Link
            to={to}
            className={classnames(
                '-mx-2 flex min-w-0 flex-shrink items-center gap-3 rounded px-2 py-1 text-base font-semibold text-content-medium transition-colors hover:bg-surface-strong hover:text-content-strong',
                className
            )}
            {...props}
        >
            <BackIcon className="flex-none" />
            <span className="truncate">{children}</span>
        </Link>
        {separator && <PageHeaderSeparator />}
    </>
);

export default PageHeaderBreadcrumb;
